// extracted by css-extract-rspack-plugin
export default {"cls1":"WorkSelectorUpload-cls1_-w7","cls2":"WorkSelectorUpload-cls2_Jeb WorkSelectorUpload-cls1_-w7"};